import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';


export default function validateInput(data) {
	let errors = {};
	
	if(Validator.isEmpty(data.email)){
		errors.email = "Please insert your email/username";
	}
	if(Validator.isEmpty(data.password)){
		errors.password = "Please insert your password";
	}
	return {
		errors,
		isValid: isEmpty(errors)
	}
};
